import { AuthToken, RefreshToken } from "@pcp/core/interfaces";
import { AuthClaims } from "@pcp/core/interfaces";
import { DateTime } from "luxon";

export class TokenError extends Error {
    constructor(message: string) {
        super(message);
    }
}

export class TokenIsExpiredError extends TokenError {
    constructor(
        public readonly token: string,
        public readonly refreshToken: string,
        public readonly decodedToken: AuthClaims,
        public readonly expiredAt: DateTime,
    ) {
        super('Token is expired');
    }
}

export class TokenIsInvalidError extends TokenError {
    constructor(
        public readonly token: string,
        public readonly refreshToken: string,
    ) {
        super('Token is invalid');
    }
}

export type TokensAndDecodedToken = {
    token: AuthToken;
    refreshToken: RefreshToken;
    claims: AuthClaims;
    expiresAt: DateTime;
    issuedAt: DateTime;
};
